import PageContainer from "layouts/components/pageContainer";
import { apiMethod } from "api/campaignRequest";
import { routes } from "routes";
import TableComponent from "components/table";
import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import {
  EyeOutlined,
} from "@ant-design/icons";
import moment from "moment";

const CampaignRequests = () => {

  const navigate = useNavigate();
  const columns = [

    {
      title: "Title",
      dataIndex: "title",
      sorter: true,
      dataType: "text",
    },
    {
      title: "Brand",
      dataIndex: "brand",
      sorter: false,
      dataType: "text",
      render: (brand: any) => {
        return <span>{brand?.brandEntityName}</span>
      }
    },
    {
      title: "Budget",
      dataIndex: "budget",
      sorter: true,
      dataType: "text",
    },
    {
      title: "Days",
      dataIndex: "days",
      sorter: true,
      dataType: "text",
    },
    {
      title: "Status",
      dataIndex: "campaignStatusName",
      sorter: false,
      dataType: "text",
    },
    {
      title: "Date",
      // dataIndex: "createdAt",
      sorter: false,
      dataType: "text",
      render: (row: any) => {
        return row?.leatestRequestDate ? moment(row?.leatestRequestDate?.split('T')?.[0]).format('MM/DD/YYYY') : '-';
        // console.log(row, "row")
        // return row?.leatestRequestDate ? moment(row?.leatestRequestDate?.split('T')?.[0]).format('MM/DD/YYYY') : '-';
      }
    },
    {
      title: "Actions", dataType: "actions", width: 96, render: (row: any) => {
        return (
          <Button
            type="text"
            className="ant-btn-icon-only"
            onClick={() => {
              navigate(`${String(routes.campaignRequests.view?.path)?.replaceAll(":id", row.id)}`);
            }}
          >
            <EyeOutlined />
          </Button>
        )
      }
    },
  ];

  return (
    <PageContainer
      title={"Campaign Requests"}
    >
      <TableComponent
        apiMethod={apiMethod}
        apiKeyNames={{ list: "list" }}
        columns={columns}
        customAction={true}
        viewRoute={routes.campaignRequests.view}
      />
    </PageContainer>
  );
};

export default CampaignRequests;
